// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3TIFo","resendInfoText":"OnGoingPaymentBox_resendInfoText__29GlQ"};